





















































































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { BibliographyRealDetailBibliography } from '@/api'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { CollectionFlag, Prefix } from '@/types'
@Component({
  components: { IconBibliography }
})
export default class BibliographyRealInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  input!: BibliographyRealDetailBibliography

  get displayBibliographyId() {
    if (this.input.bibliographyId < 1) {
      return ''
    }
    return (
      this.input.prefix + this.input.bibliographyId.toString().padStart(10, '0')
    )
  }

  get displayBibliographySetId() {
    if (this.input.bibliographySetId === null) {
      return ''
    }
    return (
      Prefix.Set + this.input.bibliographySetId.toString().padStart(10, '0')
    )
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  @Emit('link')
  onClickLink(): void {}
}
